var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavigatorSliderLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h39v22H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e1e8ee",
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    strokeWidth: 4,
    fill: "none",
    d: "M17.125.031v20.063"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 4,
    fill: "#96ABBA",
    height: 20,
    width: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.938v12m3-12v12",
    strokeLinecap: "round",
    stroke: "#59cdd5"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavigatorSliderLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/navigator-slider-left.01de52ba2ab9e37330d011d2c135b6e3.svg";